import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import hrApi from "./hrApi";
import { Wallet, FileText, Loader2 } from "lucide-react";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
const fmt = (v) => v == null ? "—" : `$${Number(v).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function HrPayslip() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { hrApi.get(`/public/payslip/${token}`).then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "This link is not valid.")); }, [token]);
  return (
    <div className="min-h-screen grid place-items-center bg-slate-900 p-4" data-testid="hr-payslip-public">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-2xl">
        <div className="w-12 h-12 rounded-2xl bg-indigo-100 grid place-items-center mb-4"><Wallet className="text-indigo-600" size={22} /></div>
        {err ? <div className="text-rose-600 text-sm" data-testid="payslip-err">{err}</div> : !data ? <div className="text-slate-400 inline-flex items-center gap-2"><Loader2 className="animate-spin" size={16} /> Loading…</div> : (
          <>
            <h1 className="font-heading font-extrabold text-2xl text-slate-800">Your payslip</h1>
            <p className="text-slate-500 text-sm mt-1 mb-4">{data.employee_name} · {data.week_label} · pay date {data.pay_date}</p>
            <div className="grid grid-cols-2 gap-3 mb-5">
              {[["Gross", data.gross], ["Tax", data.tax], ["Net", data.net], ["Super", data.super_total]].map(([l, v]) => (
                <div key={l} className="bg-slate-50 rounded-xl p-3"><div className="text-xs text-slate-500">{l}</div><div className="text-lg font-bold text-slate-800 font-num">{fmt(v)}</div></div>
              ))}
            </div>
            <a data-testid="payslip-download" href={`${BASE}/api/hr/public/payslip/${token}/file`} target="_blank" rel="noreferrer" className="w-full inline-flex items-center justify-center gap-2 h-12 bg-indigo-500 hover:bg-indigo-400 text-white rounded-xl font-bold"><FileText size={18} /> Download payslip (PDF)</a>
            <p className="text-xs text-slate-400 mt-4">This link is private to you. If you didn't expect this email, please contact G &amp; L One.</p>
          </>
        )}
      </div>
    </div>
  );
}
